import {
  EVENT_KEY_ARROW_DOWN,
  EVENT_KEY_ARROW_LEFT,
  EVENT_KEY_ARROW_RIGHT,
  EVENT_KEY_ARROW_UP,
} from '../../../constants/event'
import { GretaAIChatSource } from '../GretaAIChat.constants'

export const GRETA_AI_CHAT_SOURCE_SWITCH_KEYS = [
  EVENT_KEY_ARROW_DOWN,
  EVENT_KEY_ARROW_LEFT,
  EVENT_KEY_ARROW_RIGHT,
  EVENT_KEY_ARROW_UP,
]

export const QA_NAME_GRETA_AI_CHAT_SOURCE_SWITCH_OPTION = {
  [GretaAIChatSource.Crm]: 'gretaAIChatSourceSwitchCrm',
  [GretaAIChatSource.Finance]: 'gretaAIChatSourceSwitchFinance',
}
